module.exports = __webpack_public_path__ + "img/home-hero.0d436e11.webp";